module.exports = __webpack_public_path__ + "static/media/user.4e91c866.png";